import { FC, forwardRef } from 'react';
import { CoreSwitch, CoreSwitchProps } from '../_core/core-switch';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { clsx } from '../../utils';
import { Colors } from '../../constants';

export interface LabeledSwitchProps extends CoreSwitchProps {
	labelSx?: SxProps<Theme>;
	customLabel?: boolean;
}

export const LabeledSwitch = forwardRef<HTMLButtonElement, Omit<LabeledSwitchProps, 'ref'>>(({ label, labelSx, customLabel, ...props }, ref) => (
	<Box
		sx={{
			display: 'flex',
			justifyContent: 'space-between',
			alignItems: 'center',
			gap: '10px',
		}}
	>
		{customLabel ? label : <Typography sx={clsx(labelSx, props.disabled ? { color: Colors.grayDark } :  {})}>{label}</Typography>}

		<CoreSwitch {...props} ref={ref} />
	</Box>
));

LabeledSwitch.displayName = 'LabeledSwitch';
